import { CustomGradeCode } from '@/customGrading/constants/customGradeCodes';

import { IMAGE, VIDEO_MONO, VIDEO_STEREO } from '../constants/mediaSourceTypes';

export enum SetupPresetType {
  View360Girdle = 1,
  Video360Pavilion = 2,
  ViBOXVerticalSwinging = 3,
  ViBOXSwinging = 4,
  IOffice = 7,
  IAsetBlack = 10,
  IAsetWhite = 11,
  IArrows = 13,
  IHeart = 14,
  IMunsell = 15,
  IMunsellCloseup = 16,
  DarkfieldCrown = 23,
  ViBOXGyroFire = 28,
  IFaceUpFluor = 31,
  GyroDarkfield = 32,
  GyroFire2D = 33,
  LPFaceUpFluor = 38,
  Scintillation = 40,
  LPOffice = 41,
  ITColorOutdoor = 42,
  Fire = 43,
  LPFire = 44,
  Office = 45,
  LPAsetBlack = 47,
  IDarkfield = 50,
  Darkfield = 51,
  IPavColorLab = 52,
  LPPavColorLab = 53,
  IFire = 54,
  ISideFluor = 55,
  ITColorLab = 56,
  ITColorUVFree = 57,
  IAsetBlackTabledown = 58,
  IBrightfield = 59,
  Brightfield = 60,
  IWhitedom = 61,
  IFaceUpFluorDark = 62,
  ISideFluorDark = 63,
  LPTColorLab = 64,
  LPSideFluor = 68,
  PavilionColorLabSwinging = 75,
  Vision360Girdle = 81,
  Vision360Pavilion = 82,
  Rough360Girdle = 88,
  Rough360Pavilion = 89,
  ViBOX2Vertical = 98,
  ViBOX2Pavilion = 99,
  DeadZones = 130,
  OctonusZone = 131,
  HumanDeadZones = 132,
  IViBox2BeautyVertical = 140,
  IViBox2Pavillion = 141,
  ViBox2BeautyVerticalSwinging = 142,
  ViBox2PavillionSwinging = 143,
  ViBox2OfficeVertical = 144,
  ViBox2B2BVertical = 145,
  IViBox2OfficeVertical = 146,
  IViBox2B2BVertical = 147,
  ViBox2OfficeVerticalSwinging = 148,
  ViBox2B2BVerticalSwinging = 149,
  ViBox2B2BTableDown = 159,
  ViBox2MicroSwinging = 160,
  IOfficeFCGrading = 161,
  OfficeFCGrading = 162,
  IFancyColorEstimation = 163,
  FancyColorEstimation = 164,
  OctonusZoneBrainVision = 173,
}

export const SETUP_PRESET_GRADING_CODE_MAP: Map<SetupPresetType, CustomGradeCode> = new Map([
  [SetupPresetType.ViBox2B2BTableDown, CustomGradeCode.ColorViBox3],
  [SetupPresetType.ViBox2B2BVertical, CustomGradeCode.ColorViBox2],
  [SetupPresetType.PavilionColorLabSwinging, CustomGradeCode.Color],
]);

export const I_FACEUP_FLUOR = SetupPresetType.IFaceUpFluor;
export const GYRO_DARKFIELD = SetupPresetType.GyroDarkfield;
export const GYRO_FIRE_2D = SetupPresetType.GyroFire2D;
export const VIDEO_360_GIRDLE = SetupPresetType.View360Girdle;
export const VIDEO_360_PAVILION = SetupPresetType.Video360Pavilion;
export const DARKFIELD_CROWN = SetupPresetType.DarkfieldCrown;
export const VIBOX_GYRO_FIRE = SetupPresetType.ViBOXGyroFire;
export const VIBOX_VERTICAL_SWINGING = SetupPresetType.ViBOXVerticalSwinging;
export const VIBOX_SWINGING = SetupPresetType.ViBOXSwinging;
export const I_OFFICE = SetupPresetType.IOffice;
export const I_ASET_BLACK = SetupPresetType.IAsetBlack;
export const I_ASET_WHITE = SetupPresetType.IAsetWhite;
export const I_ARROWS = SetupPresetType.IArrows;
export const I_HEARTS = SetupPresetType.IHeart;
export const I_MUNSELL_CLOSEUP = SetupPresetType.IMunsellCloseup;
export const I_MUNSELL = SetupPresetType.IMunsell;
export const I_DARKFIELD = SetupPresetType.IDarkfield;
export const DARKFIELD = SetupPresetType.Darkfield;
export const I_SIDE_FLUOR = SetupPresetType.ISideFluor;
export const I_ASET_BLACK_TABLEDOWN = SetupPresetType.IAsetBlackTabledown;
export const I_WHITEDOME = SetupPresetType.IWhitedom;
export const I_FACEUP_FLUOR_DARK = SetupPresetType.IFaceUpFluorDark;
export const I_SIDE_FLUOR_DARK = SetupPresetType.ISideFluorDark;

export const GYRO_SETUP_PRESETS = [SetupPresetType.GyroDarkfield, SetupPresetType.GyroFire2D];

export const LP_FACEUP_FLUOR = SetupPresetType.LPFaceUpFluor;
export const LP_TCOLOR_LAB = SetupPresetType.LPTColorLab;
export const SCINTILLATION = SetupPresetType.Scintillation;
export const LP_OFFICE = SetupPresetType.LPOffice;
export const I_TCOLOR_OUTDOOR = SetupPresetType.ITColorOutdoor;
export const FIRE = SetupPresetType.Fire;
export const LP_FIRE = SetupPresetType.LPFire;
export const OFFICE = SetupPresetType.Office;
export const LP_ASET_BLACK = SetupPresetType.LPAsetBlack;
export const I_PAVCOLOR_LAB = SetupPresetType.IPavColorLab;
export const LP_PAVCOLOR_LAB = SetupPresetType.LPPavColorLab;
export const I_FIRE = SetupPresetType.IFire;
export const I_TCOLOR_LAB = SetupPresetType.ITColorLab;
export const I_TCOLOR_UVFREE = SetupPresetType.ITColorUVFree;
export const I_BRIGHTFIELD = SetupPresetType.IBrightfield;
export const BRIGHTFIELD = SetupPresetType.Brightfield;
export const LP_SIDE_FLUOR = SetupPresetType.LPSideFluor;
export const VISION_360_GIRDLE = SetupPresetType.Vision360Girdle;
export const VISION_360_PAVILION = SetupPresetType.Vision360Pavilion;
export const ROUGH_360_GIRDLE = SetupPresetType.Rough360Girdle;
export const ROUGH_360_PAVILION = SetupPresetType.Rough360Pavilion;
export const VIBOX2_VERTICAL = SetupPresetType.ViBOX2Vertical;
export const VIBOX2_PAVILION = SetupPresetType.ViBOX2Pavilion;
export const DEAD_ZONES = SetupPresetType.DeadZones;

const EXCLUDED_SINGLE_SCALE_SETUP_PRESETS = [
  SetupPresetType.IMunsell,
  SetupPresetType.IMunsellCloseup,
  SetupPresetType.Vision360Girdle,
  SetupPresetType.Vision360Pavilion,
  SetupPresetType.Rough360Girdle,
  SetupPresetType.Rough360Pavilion,
];

export const NON_DIAMOND_SETUP_PRESETS = [
  SetupPresetType.View360Girdle,
  SetupPresetType.Video360Pavilion,
  SetupPresetType.ViBOX2Vertical,
  SetupPresetType.ViBOX2Pavilion,
  SetupPresetType.Rough360Girdle,
  SetupPresetType.Rough360Pavilion,
  SetupPresetType.Vision360Girdle,
  SetupPresetType.Vision360Pavilion,
  SetupPresetType.ViBOXVerticalSwinging,
  SetupPresetType.ViBOXSwinging,
  SetupPresetType.IOffice,
  SetupPresetType.IViBox2BeautyVertical,
  SetupPresetType.IViBox2Pavillion,
  SetupPresetType.ViBox2BeautyVerticalSwinging,
  SetupPresetType.ViBox2PavillionSwinging,
  SetupPresetType.ViBox2OfficeVertical,
  SetupPresetType.ViBox2B2BVertical,
  SetupPresetType.IViBox2OfficeVertical,
  SetupPresetType.IViBox2B2BVertical,
  SetupPresetType.ViBox2OfficeVerticalSwinging,
  SetupPresetType.ViBox2B2BVerticalSwinging,
];

export const FULL_360_VIEW_SETUP_PRESETS = [
  SetupPresetType.View360Girdle,
  SetupPresetType.Vision360Girdle,
  SetupPresetType.ViBOX2Vertical,
  SetupPresetType.ViBox2OfficeVertical,
  SetupPresetType.ViBox2B2BVertical,
];

export const CROWN_360_VIEW_SETUP_PRESETS = [
  SetupPresetType.Vision360Pavilion,
  SetupPresetType.Video360Pavilion,
  SetupPresetType.ViBOX2Pavilion,
];

export const FOUR_VIEW_SETUP_PRESETS = [...FULL_360_VIEW_SETUP_PRESETS, ...CROWN_360_VIEW_SETUP_PRESETS];

export class SetupPresetModel {
  id!: SetupPresetType;
  direction?: number;
  title!: string;
  mediaSourceType?: number;
  bg?: string;
}

export default class SetupPreset extends SetupPresetModel {
  isStandard: boolean;

  constructor(modelData: SetupPresetModel, isStandard: boolean) {
    super();

    this.id = modelData.id;
    this.direction = modelData.direction;
    this.title = modelData.title;
    this.mediaSourceType = modelData.mediaSourceType;
    this.bg = modelData.bg;

    this.isStandard = isStandard;
  }

  get isImage() {
    return this.mediaSourceType === IMAGE;
  }

  get isVideo() {
    return this.mediaSourceType === VIDEO_MONO || this.mediaSourceType === VIDEO_STEREO;
  }

  get isFourView() {
    return FOUR_VIEW_SETUP_PRESETS.includes(this.id);
  }

  get isGyro() {
    return GYRO_SETUP_PRESETS.includes(this.id);
  }

  get isPossibleSingleScale() {
    return !EXCLUDED_SINGLE_SCALE_SETUP_PRESETS.includes(this.id);
  }
}
